import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { IconSpriteModule } from 'ng-svg-icon-sprite';

import { ModalOptimizationComponent } from './modal-optimization.component';
import { ModalOptimizationService } from './modal-optimization.service';
import { TranslateModule } from '@ngx-translate/core';
import { IconSpriteModule } from '@app/components/icon-sprite/icon-sprite.module';

@NgModule({
  declarations: [ModalOptimizationComponent],
  imports: [CommonModule, IconSpriteModule, TranslateModule],
  exports: [ModalOptimizationComponent],
  providers: [ModalOptimizationService],
})
export class ModalOptimizationModule {}
